module.exports = __webpack_public_path__ + "2d8f301e88e6375492f9d46b47b0413f.svg";